import React from 'react';
const context = React.createContext('hello_secondpagefilters');
export default context;